import React, { createContext, useContext, useState } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useEventSlug } from '../../../shared/hooks/useEventSlug';
import { Modal } from '../components/Modal';
import { useTranslate } from '../../../shared/hooks/useTranslate';
import { useLayoutConfig } from './useLayoutConfig';
import { Link, Navigate } from 'react-router-dom';
import { useAbsolutePath } from './useAbsolutePath';

const ExpiredTokenModal = () => {
	const { __ } = useTranslate();
	const { isTokenExpired } = useLayoutConfig();
	const { prefix } = useAbsolutePath();

	const [showModal, setShowModal] = useState(isTokenExpired);

	const closeModal = () => {
		setShowModal(false);
	};

	return (
		<Modal
			extraClassName="modal-warning flashModal-component"
			isOpen={showModal}
			onRequestClose={closeModal}
		>
			<div className="modal-header">
				<button type="button" className="close" onClick={closeModal}>
					<span aria-hidden="true">&times;</span>
				</button>
				<img
					src="data:image/png;base64,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"
					width="100"
					height="100"
				/>
			</div>
			<div className="modal-body">
				<p>
					<strong>
						{__('Automatic login link has already been used or has expired.')}
					</strong>
				</p>
				<p>
					{__(
						'To register to this event, click on the button below to refresh your login link.'
					)}
				</p>
			</div>
			<div className="modal-footer">
				<Link
					to={`${prefix}/login?state=expired-token#start`}
					className="btn btn-inverse"
					reloadDocument
				>
					{__('Ask for a new login link')}
				</Link>
			</div>
		</Modal>
	);
};

const LoggedInModal = () => {
	const eventSlug = useEventSlug();
	const { __ } = useTranslate();
	const { user } = useAuth();
	const { hasJustLoggedIn } = useLayoutConfig();

	const [showModal, setShowModal] = useState(hasJustLoggedIn);

	const closeModal = () => {
		setShowModal(false);
	};

	const deleteTokenMutation = useMutation({
		mutationFn: async (userId: string) => {
			await axios.post(`/users/deleteusermagictokens/${userId}`);
		},
		onSuccess: () => {
			console.info('Magic link token deleted.');
		},
		onError: (err) => {
			console.error(err);
		},
	});

	return (
		<Modal
			extraClassName="modal-success flashModal-component"
			isOpen={showModal}
			shouldCloseOnOverlayClick={false}
			onRequestClose={closeModal}
		>
			<div className="modal-header">
				<img
					src="data:image/svg+xml;utf8;base64,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"
					width="100"
					height="100"
				/>
			</div>
			<div className="modal-body">
				{user && (
					<p>
						{(user.firstname && user.firstname !== '') ||
						(user.lastname && user.lastname !== '') ? (
							<strong className="text-capitalize">
								{user.firstname} {user.lastname}
							</strong>
						) : (
							<strong>{user.mail}</strong>
						)}{' '}
						{__('you are now logged in.')}
					</p>
				)}

				<p className="text-muted">
					{__('This is not me?')}{' '}
					<a href={`/${eventSlug}/logout`}>{__('Log me out')}</a>
				</p>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn btn-default"
					onClick={() => {
						if (user) {
							deleteTokenMutation.mutate(user.id);
						}

						closeModal();
					}}
				>
					{__('Ok')}
				</button>
			</div>
		</Modal>
	);
};

const AuthContext = createContext<
	| {
			isLoggedIn: true;
			isAdmin: boolean;
			isTest: boolean;
			token: string;
			user: {
				id: string;
				mail: string;
				firstname: string;
				lastname: string;
				status: number | null;
			};
	  }
	| {
			isLoggedIn: false;
			isAdmin: false;
			isTest: false;
			token: null;
			user: null;
	  }
>({
	isLoggedIn: false,
	isAdmin: false,
	isTest: false,
	token: null,
	user: null,
});

type AuthResponse = {
	id: string;
	mail: string;
	firstname: string;
	lastname: string;
	status: number | null;
	isAdmin: boolean;
	isTest: boolean;
	token: string;
} | null;

const useAuthQuery = () => {
	const eventSlug = useEventSlug();

	return useQuery({
		queryKey: ['event_auth', eventSlug],
		queryFn: async () => {
			const { data } = await axios.get(`/auth/event/${eventSlug}`);
			return data as AuthResponse;
		},
		refetchOnWindowFocus: false,
		staleTime: 5000,
	});
};

const AuthProvider = ({ children }: { children?: React.ReactNode }) => {
	const authQuery = useAuthQuery();

	if (authQuery.isPending) {
		return null;
	}

	return (
		<AuthContext.Provider
			value={
				authQuery.data
					? {
							isLoggedIn: true,
							isAdmin: authQuery.data.isAdmin,
							isTest: authQuery.data.isTest,
							token: authQuery.data.token,
							user: {
								id: authQuery.data.id,
								mail: authQuery.data.mail,
								firstname: authQuery.data.firstname,
								lastname: authQuery.data.lastname,
								status: authQuery.data.status,
							},
						}
					: {
							isLoggedIn: false,
							isAdmin: false,
							isTest: false,
							token: null,
							user: null,
						}
			}
		>
			{children}
			<LoggedInModal />
			<ExpiredTokenModal />
		</AuthContext.Provider>
	);
};

const useAuth = () => {
	return useContext(AuthContext);
};

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
	const { isLoggedIn } = useAuth();
	const { prefix } = useAbsolutePath();

	if (!isLoggedIn) {
		return <Navigate to={`${prefix}/login`} replace />;
	}

	return children;
};

const useProtectedAuth = () => {
	const auth = useContext(AuthContext);

	if (!auth.isLoggedIn) {
		throw new Error('Authentication error.');
	}

	return auth;
};

export { AuthProvider, useAuth, ProtectedRoute, useProtectedAuth };
